import { useTranslation } from 'react-i18next';

import pageHeaderStyles from '@features/campaigns/shared/components/PageHeader/PageHeader.module.scss';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

interface PageHeaderProps {
  closeCallback: () => void;
}

export function PageHeader({ closeCallback }: PageHeaderProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);

  return (
    <div className={pageHeaderStyles.container}>
      <div className='content-wrapper'>
        <header className={pageHeaderStyles.headerWrapper}>
          <h3 className={pageHeaderStyles.header}>{t('builder.headers.newCampaign.type.common')}</h3>
          <button
            className={pageHeaderStyles.close}
            data-testid='close-thematic-package-upsell-button'
            onClick={closeCallback}
          >
            <i className='pi pi-times'></i>
          </button>
        </header>
      </div>
    </div>
  );
}
